import { routes } from "@/config/routes";
import { DUMMY_ID } from "@/config/constants";
import {
  PiShoppingCart,
  PiHeadset,
  PiPackage,
  PiChartBar,
  PiCurrencyDollar,
  PiSquaresFour,
  PiGridFour,
  PiFeather,
  PiChartLineUp,
  PiMapPinLine,
  PiUserGear,
  PiBellSimpleRinging,
  PiUser,
  PiEnvelopeSimpleOpen,
  PiSteps,
  PiCreditCard,
  PiTable,
  PiBrowser,
  PiHourglassSimple,
  PiUserCircle,
  PiShootingStar,
  PiRocketLaunch,
  PiFolderLock,
  PiBinoculars,
  PiHammer,
  PiNoteBlank,
  PiUserPlus,
  PiShieldCheck,
  PiLockKey,
  PiChatCenteredDots,
  PiCalendarPlus,
  PiHouseLine,
  PiAirplaneTilt,
  PiPokerChip,
  PiFolderNotch,
  PiListNumbers,
  PiCaretCircleUpDown,
  PiBriefcase,
} from "react-icons/pi";
import { FaBookReader } from "react-icons/fa";

import { GoHome } from "react-icons/go";
import { FaPlus } from "react-icons/fa6";
import { roles } from "@/static/roles/roles";
import { Role } from "@/types/global";
export interface DropDown {
  name: string;
  href: string;
  badge: string;
  role?: Role;
}
// import {roles}
import { MdCurrencyExchange } from "react-icons/md";
import { RiGuideFill } from "react-icons/ri";
import { IoInformationOutline } from "react-icons/io5";
// Note: do not add href in the label object, it is rendering as label
export const menuItems = [
  // // label start
  // {
  //   name: 'پیشنهاد',
  // },
  // // label end
  // {
  //   name: 'پیشنهاد ها',
  //   href: '/request',
  //   icon: <PiFolderNotch />,
  // },
  // {
  //   name: "صفحه اصلی",
  //   href: "/",
  //   icon: <GoHome />,
  // },
  {
    name: "میزکار",
    href: routes.dashboard.page,
    icon: <PiPackage />,
  },
  // {
  //   name: 'Logistics',
  //   href: routes.logistics.dashboard,
  //   icon: <PiPackage />,
  // },
  // {
  //   name: 'E-Commerce',
  //   href: routes.dashboard.page,
  //   icon: <PiShoppingCart />,
  // },
  // {
  //   name: 'Analytics',
  //   href: routes.analytics,
  //   icon: <PiChartBar />,
  //   badge: '',
  // },
  // {
  //   name: 'Support',
  //   href: routes.support.dashboard,
  //   icon: <PiHeadset />,
  // },
  // // label start
  // {
  //   name: 'Apps Kit',
  // },
  // // label end
  // {
  //   name: 'E-Commerce',
  //   href: '#',
  //   icon: <PiShoppingCart />,
  //   dropdownItems: [
  //     {
  //       name: 'Products',
  //       href: routes.eCommerce.products,
  //       badge: '',
  //     },
  //     {
  //       name: 'Product Details',
  //       href: routes.eCommerce.productDetails(DUMMY_ID),
  //     },
  //     {
  //       name: 'Create Product',
  //       href: routes.eCommerce.createProduct,
  //     },
  //     {
  //       name: 'Edit Product',
  //       href: routes.eCommerce.ediProduct(DUMMY_ID),
  //     },
  //     {
  //       name: 'Categories',
  //       href: routes.eCommerce.categories,
  //     },
  //     {
  //       name: 'Create Category',
  //       href: routes.eCommerce.createCategory,
  //     },
  //     {
  //       name: 'Edit Category',
  //       href: routes.eCommerce.editCategory(DUMMY_ID),
  //     },
  //     {
  //       name: 'Orders',
  //       href: routes.eCommerce.orders,
  //     },
  //     {
  //       name: 'Order Details',
  //       href: routes.eCommerce.orderDetails(DUMMY_ID),
  //     },
  //     {
  //       name: 'Create Order',
  //       href: routes.eCommerce.createOrder,
  //     },
  //     {
  //       name: 'Edit Order',
  //       href: routes.eCommerce.editOrder(DUMMY_ID),
  //     },
  //     {
  //       name: 'Reviews',
  //       href: routes.eCommerce.reviews,
  //     },
  //     {
  //       name: 'Shop',
  //       href: routes.eCommerce.shop,
  //     },
  //     {
  //       name: 'Cart',
  //       href: routes.eCommerce.cart,
  //     },
  //     {
  //       name: 'Checkout & Payment',
  //       href: routes.eCommerce.checkout,
  //     },
  //   ],
  // },
  // {
  //   name: 'پشتیبانی',
  //   href: '#',
  //   icon: <PiHeadset />,
  //   dropdownItems: [
  //     {
  //       name: 'صندوق دریافت',
  //       href: routes.support.inbox,
  //     },
  //     {
  //       name: 'تکه‌ها',
  //       href: routes.support.snippets,
  //     },
  //     {
  //       name: 'قالب',
  //       href: routes.support.templates,
  //     },
  //   ],
  // },
  {
    name: "ادمین",
    href: "#",
    icon: <PiHeadset />,
    role: "admin",
    dropdownItems: [
      {
        name: "میز کار",
        role: roles.chatroom_watcher,
        href: routes.admin.dashboard,
      },
      {
        name: "نقش‌ها و مجوزها",
        role: roles.user_manager,
        href: routes.admin.rolesPermissions,
      },
      {
        name: "گزارشات",
        role: roles.payment_maker,
        href: routes.admin.statistics,
      },
    ],
  },
  // {
  //   name: "حواله ها",
  //   href: "#",
  //   icon: <PiCurrencyDollar />,
  //   dropdownItems: [
  //     {
  //       name: "لیست حواله ها",
  //       href: routes.invoice.home,
  //     },
  //     {
  //       name: "ساختن",
  //       href: routes.invoice.create,
  //     },
  //   ],
  // },
  {
    name: "لیست حواله‌ها",
    href: routes.invoice.home,
    icon: <PiCurrencyDollar />,
  },
  {
    name: "ساخت حواله جدید",
    href: routes.invoice.create,
    icon: <FaPlus />,
  },
  {
    name: "نرخ ارز ها",
    href: routes.comingSoon,
    // href: '/new-request',
    icon: <MdCurrencyExchange />,
    badge: "به زودی",
  },
  {
    name: "بلاگ",
    href: routes.executive.blog,
    // href: '/new-request',
    icon: <PiSquaresFour />,
    badge: "به زودی",
  },
  {
    name: "پشتیبانی",
    href: routes.support.dashboard,
    // href: '/new-request',
    icon: <PiHeadset />,
    // badge: "به زودی",
  },
  {
    name: "راهنما",
    href: routes.guide,
    // href: '/new-request',
    icon: <RiGuideFill />,
    // badge: "به زودی",
  },
  {
    name: "درباره‌ی ما",
    href: routes.aboutus,
    // href: '/new-request',
    icon: <IoInformationOutline  />
    ,
    // badge: "به زودی",
  },
  {
    name: "شرایط و قوانین",
    href: routes.rule,
    // href: '/new-request',
    icon: <FaBookReader />,
    // badge: "به زودی",
  },
  // {
  //   name: 'Logistics',
  //   href: '#',
  //   icon: <PiPackage />,
  //   dropdownItems: [
  //     {
  //       name: 'Shipment List',
  //       href: routes.logistics.shipmentList,
  //     },
  //     {
  //       name: 'Shipment Details',
  //       href: routes.logistics.shipmentDetails(DUMMY_ID),
  //     },
  //     {
  //       name: 'Create Shipment',
  //       href: routes.logistics.createShipment,
  //     },
  //     {
  //       name: 'Edit Shipment',
  //       href: routes.logistics.editShipment(DUMMY_ID),
  //     },
  //     {
  //       name: 'Customer Profile',
  //       href: routes.logistics.customerProfile,
  //     },
  //     {
  //       name: 'Tracking',
  //       href: routes.logistics.tracking(DUMMY_ID),
  //     },
  //   ],
  // },
  // {
  //   name: 'File Manager',
  //   href: routes.file.manager,
  //   icon: <PiFolderNotch />,
  // },
  // {
  //   name: 'Event Calendar',
  //   href: routes.eventCalendar,
  //   icon: <PiCalendarPlus />,
  // },
  // {
  //   name: 'Roles & Permissions',
  //   href: routes.rolesPermissions,
  //   icon: <PiFolderLock />,
  // },
  // {
  //   name: 'Point of Sale',
  //   href: routes.pos.index,
  //   icon: <PiCreditCard />,
  //   badge: 'Update',
  // },
  // // label start
  // {
  //   name: 'Search & Filters',
  // },
  // {
  //   name: 'Real Estate',
  //   href: routes.searchAndFilter.realEstate,
  //   icon: <PiHouseLine />,
  // },
  // {
  //   name: 'Flight Booking',
  //   href: routes.searchAndFilter.flight,
  //   icon: <PiAirplaneTilt />,
  //   badge: 'Update',
  // },
  // {
  //   name: 'NFT',
  //   href: routes.searchAndFilter.nft,
  //   icon: <PiPokerChip />,
  // },
  // // label end
  // // label start
  // {
  //   name: 'Widgets',
  // },
  // // label end
  // {
  //   name: 'Cards',
  //   href: routes.widgets.cards,
  //   icon: <PiSquaresFour />,
  // },
  // {
  //   name: 'Icons',
  //   href: routes.widgets.icons,
  //   icon: <PiFeather />,
  // },
  // {
  //   name: 'Charts',
  //   href: routes.widgets.charts,
  //   icon: <PiChartLineUp />,
  // },
  // {
  //   name: 'Banners',
  //   href: routes.widgets.banners,
  //   icon: <PiImage />,
  // },
  // {
  //   name: 'Maps',
  //   href: routes.widgets.maps,
  //   icon: <PiMapPinLine />,
  // },
  // // label start
  // {
  //   name: 'Forms',
  // },
  // // label end
  // {
  //   name: 'Account Settings',
  //   href: routes.forms.profileSettings,
  //   icon: <PiUserGear />,
  // },
  // {
  //   name: 'Notification Preference',
  //   href: routes.forms.notificationPreference,
  //   icon: <PiBellSimpleRinging />,
  // },
  // {
  //   name: 'Personal Information',
  //   href: routes.forms.personalInformation,
  //   icon: <PiUser />,
  // },
  // {
  //   name: 'Newsletter',
  //   href: routes.forms.newsletter,
  //   icon: <PiEnvelopeSimpleOpen />,
  // },
  // {
  //   name: 'Multi Step',
  //   href: routes.multiStep,
  //   icon: <PiSteps />,
  // },
  // {
  //   name: 'Payment Checkout',
  //   href: routes.eCommerce.checkout,
  //   icon: <PiCreditCard />,
  // },
  // // label start
  // {
  //   name: 'Tables',
  // },
  // // label end
  // {
  //   name: 'Basic',
  //   href: routes.tables.basic,
  //   icon: <PiGridFour />,
  // },
  // {
  //   name: 'Collapsible',
  //   href: routes.tables.collapsible,
  //   icon: <PiCaretCircleUpDown />,
  // },
  // {
  //   name: 'Enhanced',
  //   href: routes.tables.enhanced,
  //   icon: <PiTable />,
  // },
  // {
  //   name: 'Sticky Header',
  //   href: routes.tables.stickyHeader,
  //   icon: <PiBrowser />,
  // },
  // {
  //   name: 'Pagination',
  //   href: routes.tables.pagination,
  //   icon: <PiListNumbers />,
  // },
  // {
  //   name: 'Search',
  //   href: routes.tables.search,
  //   icon: <PiHourglassSimple />,
  // },
  // // label start
  // {
  //   name: 'Pages',
  // },
  // {
  //   name: 'Profile',
  //   href: routes.profile,
  //   icon: <PiUserCircle />,
  // },
  // {
  //   name: 'Welcome',
  //   href: routes.welcome,
  //   icon: <PiShootingStar />,
  // },
  // {
  //   name: 'Coming soon',
  //   href: routes.comingSoon,
  //   icon: <PiRocketLaunch />,
  // },
  // {
  //   name: 'Access Denied',
  //   href: routes.accessDenied,
  //   icon: <PiFolderLock />,
  // },
  // {
  //   name: 'Not Found',
  //   href: routes.notFound,
  //   icon: <PiBinoculars />,
  // },
  // {
  //   name: 'Maintenance',
  //   href: routes.maintenance,
  //   icon: <PiHammer />,
  // },
  // {
  //   name: 'Blank',
  //   href: routes.blank,
  //   icon: <PiNoteBlank />,
  // },

  // // label start
  // {
  //   name: "امنیت",
  // },
  // // label end
  // {
  //   name: "ثبت نام",
  //   href: "#",
  //   icon: <PiUserPlus />,
  //   dropdownItems: [
  //     {
  //       name: "ثبت نام در سایت",
  //       href: routes.auth.signUp,
  //     },
  //   ],
  // },
  // {
  //   name: "ورود",
  //   href: "#",
  //   icon: <PiShieldCheck />,
  //   dropdownItems: [
  //     {
  //       name: "ورود به سایت",
  //       href: routes.auth.signIn,
  //     },
  //   ],
  // },
  //   {
  //     name: 'فراموشی رمز',
  //     href: '#',
  //     icon: <PiLockKey />,
  //     dropdownItems: [
  //       {
  //         name: 'Modern Forgot password',
  //         href: routes.auth.forgotPassword1,
  //       },
  //       {
  //         name: 'Vintage Forgot password',
  //         href: routes.auth.forgotPassword2,
  //       },
  //       {
  //         name: 'Trendy Forgot password',
  //         href: routes.auth.forgotPassword,
  //       },
  //       {
  //         name: 'Elegant Forgot password',
  //         href: routes.auth.forgotPassword4,
  //       },
  //       {
  //         name: 'Classic Forgot password',
  //         href: routes.auth.forgotPassword5,
  //       },
  //     ],
  //   },
  //   {
  //     name: 'OTP Pages',
  //     href: '#',
  //     icon: <PiChatCenteredDots />,
  //     dropdownItems: [
  //       {
  //         name: 'Modern OTP page',
  //         href: routes.auth.otp1,
  //       },
  //       {
  //         name: 'Vintage OTP page',
  //         href: routes.auth.otp2,
  //       },
  //       {
  //         name: 'Trendy OTP page',
  //         href: routes.auth.otp3,
  //       },
  //       {
  //         name: 'Elegant OTP page',
  //         href: routes.auth.otp4,
  //       },
  //       {
  //         name: 'Classic OTP page',
  //         href: routes.auth.otp5,
  //       },
  //     ],
  //   },
];
